import React, { PureComponent } from 'react';

import ModalContainer from '@bit/wavfichacerta.fichacerta.modals.modal-container';
import { PrimaryButton } from '@bit/wavfichacerta.fichacerta.shared-styles.buttons';
import { StyledRow } from '@bit/wavfichacerta.fichacerta.shared-styles.rows';
import { Container, SpanTitle, GrayText } from '../form/fieldModal/formModalFields.styled';

class InsuficientCreditsModal extends PureComponent {

  renderFooter = () => (
    <StyledRow padding='0 3em' justify="center">
      <PrimaryButton data-testid="go-back-button" onClick={this.props.closeModal} >Fechar</PrimaryButton>
      <PrimaryButton data-testid="go-back-button" onClick={this.props.notShowWarningAgain} style={{marginLeft: 10}}>Não mostrar mais este aviso</PrimaryButton>
    </StyledRow>
  )

  renderHeader = () => (
    <SpanTitle customstyle="margin: auto;">
      ATENÇÃO
    </SpanTitle>
  )

  render() {
    let text = <React.Fragment>Você acabou de incluir uma solicitação, mas para que ela seja processada você precisa clicar no botão laranja: <b>Processar análise</b>. Caso tenha outros pretendentes para incluir, sugerimos incluí-los primeiro e depois processar as análises em conjunto.</React.Fragment>
    if(this.props.infos.cliente_forma_pagamento_id === 3) {
      text = <React.Fragment>Você acabou de incluir uma solicitação, mas para que ela seja processada você precisa clicar no botão laranja: <b>Pagar para Processar ANÁLISE</b>. Após o pagamento do PIX a análise será disponibilizada automaticamente. Caso tenha outros pretendentes para incluir, sugerimos incluí-los antes do pagamento, para processar as análises em conjunto.</React.Fragment>
    }
    return (
      <ModalContainer
        isOpen={this.props.isOpen}
        size="md"
        onClose={this.props.closeModal}
        footer={this.renderFooter()}
        header={this.renderHeader()}
      >

        <Container customstyle="text-align: center; margin: 20px auto;">
          <GrayText>
            {text}
          </GrayText>
        </Container>

      </ModalContainer>
    );
  }
}

export default InsuficientCreditsModal;